<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Entrada por Compra</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12">
              <!-- <button 
              class="btn btn-primary btn-sm" 
              @click="showModalAddEntradaCompraNew"  
              type="button">Generar desde Orden de Compra
              <i class="fa fa-plus"></i> 
              </button> -->
              <button
                :disabled="true"
                class="btn btn-primary btn-sm"
                @click="$router.push({ path: `/inventario/entrada_compra/nuevo/` })"
              >
                Nueva Entrada Compra
                <i class="fa fa-plus"></i>
              </button>
            </div>
            <div class="col-sm-12">
              <div class="form-inline justify-content-sm-end">
                <input
                  class="form-control form-control-sm rounded bright"
                  placeholder="Search"
                  v-model="searchtext"
                  type="text"
                  v-on:keyup.enter="filterData()"
                />
                <ProveedoresSelectComponent
                  style="display: block; width: 350px"
                  titulo=""
                  :current="filter"
                  @change="filterData()"
                  @onChange="filterData()"
                />
                &nbsp; &nbsp; &nbsp;
                <select
                  class="form-control form-control-sm rounded bright"
                  v-model="filtro_estado"
                  @change="filterData()"
                >
                  <option value>Todos</option>
                  <option value="9">Anulado</option>
                  <option value="A">Abierto</option>
                  <option value="B">Cerrado</option>
                </select>
                <div class="input-group-append">
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="filterData()"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                  <button
                    class="btn btn-link btn-sm"
                    type="button"
                    v-on:click="clearFilterData"
                  >
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <EntradaCompraTableComponent />
        <PaginationComponent
          :currentPage="currentPage"
          :data="dataTabla"
          @pagechanged="filterData"
        />
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalAddEntradaCompranNew"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h4 class="onboarding-title text-center">
                  Nueva Entrada de Compra basada en una Orden de Compra
                </h4>
              </div>
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <EntradaCompraNewTableComponent />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import EntradaCompraTableComponent from "@/components/inventario/entrada_compra/EntradaCompraTableComponent";
import EntradaCompraNewTableComponent from "@/components/inventario/entrada_compra/EntradaCompraNewTableComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import { mapGetters } from "vuex";

export default {
  components: {
    EntradaCompraTableComponent,
    UsuarioEnTablaComponent,
    EntradaCompraNewTableComponent,
    ProveedoresSelectComponent,
    PaginationComponent,
  },
  data() {
    return {
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      filter: {},
    };
  },
  mounted() {
    this.$store.dispatch("entradascompras/fetch");
  },
  computed: {
    ...mapGetters({
      dataTabla: "entradascompras/entradas_compra",
    }),
  },
  methods: {
    showModalAddEntradaCompraNew(detalle) {
      let self = this;
      $("#modalAddEntradaCompranNew").modal();
    },
    filterData(page) {
      let proveedor;
      this.currentPage = 1;
      if (page) {
        this.currentPage = page;
      }
      if (this.filter.proveedor && this.filter.proveedor.codigo) {
        proveedor = this.filter.proveedor.codigo;
      }
      this.$store.dispatch("entradascompras/fetch", {
        page: this.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        proveedor: proveedor,
      });
    },
    clearFilterData() {
      this.$data.searchtext = "";
      this.filter.proveedor = {};
      this.filtro_estado = "";
      this.currentPage = 1;
      this.$store.dispatch("entradascompras/fetch", {
        page: 1,
        "filter[search]": this.$data.searchtext,
      });
    },
  },
};
</script>
